import { tryCatch } from './common';

export async function browserToSHA256(input: string): Promise<string> {
  const { data, error } = await tryCatch(
    (async () => {
      if (typeof window === 'undefined') {
        throw new Error('This function can only be run in the browser.');
      }

      const utf8 = new TextEncoder().encode(input);
      const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray.map((bytes) => bytes.toString(16).padStart(2, '0')).join('');
      return hashHex;
    })(),
  );
  if (error) {
    console.error('Error generating SHA256 hash:', error);
    return '';
  }
  return data;
}
